module.exports = __webpack_public_path__ + "img/stackslash-process-2-mobile.0abe3aa9.jpg";